module.exports = __webpack_public_path__ + "img/20200611_075428.7c82992b.jpg";